import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/profile/components/ProfileClient.tsx");
